import types from './types'

export const snackbarMessage = (message, icon = null, autoHide = true, allowClose = true) => ({ type: types.SNACKBAR_MESSAGE, message, icon, autoHide, allowClose })
export const snackbarClear = () => ({ type: types.SNACKBAR_CLEAR })

export default {
  snackbarMessage,
  snackbarClear,
}